import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    width: "100vw",
    height: "100vh",
    alignContent: "center",
    justifyItems: "center",
  },
  container: { height: "60vh" },
  mainPaper: {
    backgroundColor: colorsConstants.primary,
    width: "100%",
    height: "100%",
    borderRadius: 10,
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
  },
  shapesContainer: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    position: "absolute",
    overflow: "hidden",
  },
  topLeftShape: {
    backgroundColor: colorsConstants.loginModalShape,
    width: "30vmin",
    height: "30vmin",
    borderRadius: "100%",
    position: "absolute",
    left: "-15vmin",
    top: "-15vmin",
  },
  bottomRightShape: {
    backgroundColor: colorsConstants.loginModalShape,
    width: "30vmin",
    height: "30vmin",
    borderRadius: "100%",
    bottom: "-15vmin",
    right: "-15vmin",
    position: "absolute",
  },
  elementsContainer: {
    height: "100%",
    justifyContent: "space-evenly",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  },
  emailTextField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    borderRadius: "10px",
    backgroundColor: colorsConstants.loginTextFieldBackground,
    color: colorsConstants.loginTextFieldText,
  },
  textInputsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  passwordTextField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    width: "100%",
    color: colorsConstants.loginTextFieldText,
    border: "none",
  },
  passwordContainer: {
    marginTop: "16px",
    backgroundColor: colorsConstants.loginTextFieldBackground,
    borderRadius: "10px",
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
  },
  visibilityIcon: {
    fontSize: 24,
    color: colorsConstants.primary,
  },
  overlay: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: colorsConstants.transparentOverlay,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
